import React from 'react';

interface IconProps {
  fill: string;
  height: string;
  width: string;
}
function ForgotPasswordIcon({ fill, height, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '49'}
      height={height || '43'}
      fill="none"
      viewBox="0 0 49 43"
      style={{ marginLeft: '-3px' }}
    >
      <path
        fill={fill}
        d="M27.792 42.354c-2.635 0-5.194-.496-7.677-1.49-2.482-.992-4.64-2.348-6.474-4.067l2.464-2.464c1.528 1.413 3.313 2.53 5.357 3.352a16.828 16.828 0 006.33 1.232c4.775 0 8.871-1.71 12.29-5.128 3.418-3.418 5.127-7.515 5.127-12.289s-1.71-8.87-5.128-12.29c-3.418-3.417-7.514-5.127-12.289-5.127-4.774 0-8.87 1.71-12.289 5.128-3.418 3.418-5.127 7.515-5.127 12.289v1.031l4.01-4.01 2.406 2.406-8.135 8.136L.52 20.927l2.407-2.406 4.01 4.01V21.5c0-2.903.544-5.615 1.633-8.135 1.089-2.521 2.578-4.727 4.469-6.618 1.89-1.89 4.096-3.38 6.617-4.468C22.177 1.19 24.89.646 27.792.646c2.903 0 5.615.544 8.136 1.633 2.52 1.088 4.726 2.578 6.617 4.468 1.89 1.891 3.38 4.097 4.469 6.618 1.088 2.52 1.633 5.232 1.633 8.135 0 5.805-2.025 10.733-6.073 14.781-4.049 4.049-8.976 6.073-14.782 6.073zM23.21 30.38c-.535 0-1.003-.2-1.404-.601-.4-.401-.601-.87-.601-1.404V21.5c0-.535.22-1.003.659-1.404.439-.4.983-.601 1.632-.601v-2.578c0-1.184.42-2.197 1.26-3.037.841-.84 1.853-1.26 3.037-1.26s2.196.42 3.037 1.26c.84.84 1.26 1.853 1.26 3.037v2.578c.65 0 1.194.2 1.633.601.44.401.659.87.659 1.404v6.875c0 .535-.2 1.003-.602 1.404-.4.4-.869.601-1.403.601h-9.167zm2.005-10.885h5.156v-2.578c0-.726-.248-1.337-.744-1.834-.497-.496-1.108-.745-1.834-.745-.725 0-1.337.249-1.833.745-.497.497-.745 1.108-.745 1.834v2.578z"
      ></path>
    </svg>
  );
}

export default ForgotPasswordIcon;
